import { enableProdMode, importProvidersFrom, isDevMode, provideZoneChangeDetection } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { environment } from "./environments/environment";
import { AppComponent } from "./app/app.component";
import {
  uploadReducer,
  loginReducer,
  counterReducer,
  leadsReducer,
} from "./app/store/counter.reducer";
import { StoreModule } from "@ngrx/store";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatButtonModule } from "@angular/material/button";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { NgxDocViewerModule } from "ngx-doc-viewer";
import { NgxFileDropModule } from "ngx-file-drop";
import { AutocompleteLibModule } from "angular-ng-autocomplete";
import { MatDialogModule } from "@angular/material/dialog";
import { provideAnimations } from "@angular/platform-browser/animations";
import { NgxDaterangepickerMd } from "ngx-daterangepicker-material";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { SlickCarouselModule } from "ngx-slick-carousel";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { AppRoutingModule } from "./app/app-routing.module";
import { BrowserModule, bootstrapApplication } from "@angular/platform-browser";
import { NativeDateAdapter } from "@angular/material/core";
import { DataFilterService } from "./app/data-filter.service";
import { ChatService } from "./app/service/chat.service";
import { AsyncPipe } from "../node_modules/@angular/common";
import { LoaderInterceptor } from "./app/service/loader.interceptor";
import { SAVER, getSaver } from "./app/saver.provider";
import { LocationStrategy, HashLocationStrategy } from "@angular/common";
import { AuthInterceptor } from "./app/service/auth.intercepter";
// import { ImageCropperModule } from 'ngx-image-cropper';
// import { ImageCropperComponent } from 'ngx-image-cropper';
// import { ImageCropperComponent } from './image-cropper/component/image-cropper.component';
import { ServiceWorkerModule } from "@angular/service-worker";
import { HTTP_INTERCEPTORS, withInterceptorsFromDi, provideHttpClient } from "@angular/common/http";
import { provideServiceWorker } from "@angular/service-worker";
import { registerFcmServiceWorker } from "./app/service/fcm-service-worker";
import { NgApexchartsModule } from "ng-apexcharts";
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { loadingReducer } from './app/store/loading/loading.reducer';
import { LoadingEffects } from './app/store/loading/loading.effects';
import { LoadingInterceptor } from './app/core/interceptors/loading.interceptor';
import { AuthErrorInterceptor } from './app/core/interceptors/auth-error.interceptor';

if (environment.production) {
  enableProdMode();
}

const CACHE_CLEAR_KEY = 'cache_clear_v2';
async function clearBrowserCachesOnce() {
  console.log('Function Started');

  if (localStorage.getItem(CACHE_CLEAR_KEY)) {
    console.log('Already Cleared');
    return;
  }
  console.log('First Time');
  localStorage.setItem(CACHE_CLEAR_KEY, 'true')
  sessionStorage.clear();
  console.log('Session Storage Cleared');

  if ('caches' in window) {
    const cacheNames = await caches.keys();
    console.log('Caches:', cacheNames);
    await Promise.all(
      cacheNames.map(cache => caches.delete(cache))
    );
    console.log('Caches Deleted');
  }

  if ('indexedDB' in window && indexedDB.databases) {
    const databases = await indexedDB.databases();
    console.log('IndexedDB:', databases);

    await Promise.all(
      databases
        .filter(db => db.name)
        .map(db => new Promise<void>((resolve) => {
          const request = indexedDB.deleteDatabase(db.name!);
          request.onsuccess = () => resolve();
          request.onerror = () => resolve();
          request.onblocked = () => resolve();
        }))
    );
    console.log('IndexedDB Deleted');
  }
  console.log('Reloading...');
  window.location.reload();
}
clearBrowserCachesOnce().finally(() => {
  bootstrapApplication(AppComponent, {
    providers: [
      provideZoneChangeDetection(), importProvidersFrom(
        BrowserModule,
        // ImageCropperModule,
        AppRoutingModule,
        NgApexchartsModule,
        // ImageCropperComponent,
        ReactiveFormsModule,
        SlickCarouselModule,
        InfiniteScrollModule,
        FormsModule,
        NgxDaterangepickerMd.forRoot(),
        MatDialogModule,
        AutocompleteLibModule,
        NgxFileDropModule,
        AutocompleteLibModule,
        NgxDocViewerModule,
        MatProgressBarModule,
        MatButtonModule,
        MatDatepickerModule,
        MatFormFieldModule,
        //    ServiceWorkerModule.register('ngsw-worker.js', {
        //   enabled: environment.production,
        // }),
        StoreModule.forRoot({ body: uploadReducer }),
        StoreModule.forRoot({
          login: loginReducer,
        }),
        StoreModule.forRoot({ count: counterReducer }),
        StoreModule.forRoot({ leads: leadsReducer }),
        StoreModule.forFeature("chat", counterReducer),
        StoreModule.forFeature('loading', loadingReducer),
        EffectsModule.forRoot([LoadingEffects]),
        StoreRouterConnectingModule.forRoot(),
      ),
      { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
      { provide: LocationStrategy, useClass: HashLocationStrategy },
      { provide: SAVER, useFactory: getSaver },
      // { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true }, // Replaced by LoadingInterceptor
      { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
      { provide: HTTP_INTERCEPTORS, useClass: AuthErrorInterceptor, multi: true },
      AsyncPipe,
      ChatService,
      DataFilterService,
      NativeDateAdapter,
      provideHttpClient(withInterceptorsFromDi()),
      provideAnimations(),
      provideServiceWorker("ngsw-worker.js", {
        // enabled: !isDevMode(),
        enabled: environment.production,
        registrationStrategy: "registerWhenStable:30000",
      }),
    ],
  }).catch((err) => console.error(err));

});

window.addEventListener("load", () => {
  registerFcmServiceWorker();
});
